module.exports = _.isEqualWith;